const LOCAL_CUSTOMER = true ? 'test' : 'staging'

export const getCustomerFromHost = (host: string): string => {
	if (process.env.NODE_ENV === 'development') {
		if (host.includes('localhost')) {
			return LOCAL_CUSTOMER
		}
	}

	return host.split('.')[0]
}

export const getCustomerFromRequest = (req: any): string => {
	const host = req.headers.host

	if (process.env.NODE_ENV === 'development') {
		if (host.includes('localhost')) {
			return LOCAL_CUSTOMER
		}
	}

	return getCustomerFromHost(host)
}
